module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"ticket.topic":"พบปัญหาจาก Ticket","ticket.link":"ดูรายละเอียดเพิ่ม","ticket.report_by":"รายงานโดย","ticket.resolved_result":"ผลการประเมิน","ticket.reason":"ผลการวิเคราะห์"}}')
  delete Component.options._Ctor
}
